const BaseSDK = require('./base');
const crypto = require('crypto');
const os = require('os');

class AnalyticsSDK extends BaseSDK {
  static initialize(source) {
    this.client = new AnalyticsSDK(source);
  }

  static initializeExpress(source) {
    return (req, res, next) => {
      const client = new AnalyticsSDK(source);
      // - **responseTime**, optional, Specifies the time it took for server to respond. The value is in milliseconds

      client.setEventAttr('ip', req.headers['X-Forwarded-For'] || req.headers['X-Real-IP']);
      client.setEventAttr('city', req.headers['X-Arc-Country']);
      client.setEventAttr('country', req.headers['X-Arc-City']);
      client.setEventAttr('postalCode', req.headers['X-Arc-Postal']);
      client.setEventAttr('latitude', req.headers['X-Arc-Lat']);
      client.setEventAttr('longitude', req.headers['X-Arc-Lng']);
      client.setEventAttr('language', req.headers['accept-language']);
      client.setEventAttr('userAgent', req.headers['user-agent']);

      req.ABA = client;

      return next();
    };
  }

  _getEventAttrs() {
    return {
      deviceId: this._getDeviceId(),
      serverTimestamp: new Date().toISOString(),
    };
  }

  _getDeviceId() {
    return crypto
      .createHash('md5')
      .update(os.hostname())
      .digest('hex');
  }
}

module.exports = AnalyticsSDK;
